import React from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { API } from "../../backend";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "10px",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 200,
  bgcolor: "background.paper",
  boxShadow: 100,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "10px",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 200,
  bgcolor: "background.paper",
  boxShadow: 100,
  p: 4,
};
const useStyles = makeStyles({
  text: {
    fontSize: "20px",
    fontWeight: "600",
    margin: "20px 0",
    padding: "",
  },
  btn: {
    margin: "20px 0",
    padding: "15px",
    borderRadius: "10px",
    background: "red",
    color: "white",
    border: "none",
    cursor: "pointer",
  },
});

function DeleteModal({ open, setOpen, list, setDelete, toast }) {
  const handleClose = () => {
    setOpen(false);
  };
  const width = window.innerWidth;
  const classes = useStyles();

  const handleDelete = () => {
    const config = {
      method: "delete",
      url: `${API}/playlist/delete/${list._id}`,
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("_access_token"))}`,
      },
    };

    axios(config)
      .then((res) => {
        if (res.data.status === "success") {
          toast("Playlist Deleted Successfully");
          setDelete(true);
          setOpen(false);
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
        toast("Error Occured");
        setDelete(false);
        setOpen(false);
      });
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width > 768 ? style : style2}>
            <Typography className={classes.text}>
              Are you sure you want to delete this playlist?
            </Typography>
            <button className={classes.btn} onClick={handleDelete}>
              Delete Playlist
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default DeleteModal;
